import { format } from 'date-fns';
import { ja } from 'date-fns/locale/ja';

import { DinnerReservation } from '@/types/dinner';

const DinnerReservationDetails = ({
  reservations,
}: {
  yearMonth: string;
  reservations: DinnerReservation[];
}) => {
  // 日付ごとにグループ化
  const groupedReservations = reservations.reduce(
    (acc, curr) => {
      const formattedDate = format(new Date(curr.reservation_date), 'M月d日(E)', { locale: ja });
      if (!acc[formattedDate]) acc[formattedDate] = [];
      acc[formattedDate].push(curr);
      return acc;
    },
    {} as Record<string, DinnerReservation[]>
  );

  return (
    <div className="mt-4 space-y-4">
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="w-32 whitespace-nowrap border p-3 text-left">日付</th>
            <th className="w-96 min-w-[200px] whitespace-nowrap border p-3 text-left">
              利用者（児童名）
            </th>
            <th className="w-full border p-3 text-left">アレルギー</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(groupedReservations).length > 0 ? (
            Object.entries(groupedReservations).map(([date, entries]) =>
              entries.map((entry, index) => (
                <tr
                  key={entry.id}
                  className="border"
                >
                  {/* 最初の行にだけ日付を表示 */}
                  {index === 0 ? (
                    <td
                      rowSpan={entries.length}
                      className="w-32 whitespace-nowrap border p-3 text-left"
                    >
                      {date}
                    </td>
                  ) : null}
                  <td className="w-96 min-w-[200px] whitespace-nowrap border p-3 text-left">
                    {entry.child_name}
                  </td>
                  <td className="w-full border p-3 text-left">{entry.allergies || 'なし'}</td>
                </tr>
              ))
            )
          ) : (
            <tr>
              <td
                colSpan={3}
                className="border p-3 text-center"
              >
                データがありません
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DinnerReservationDetails;
